"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RatingNumber = RatingNumber;
exports["default"] = void 0;
var _fuseUtils = require("@tvg/fuse-utils");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _typography = require("../../fuse-typography-element/src/typography");
var _config = require("./config");
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
var propTypes = {
  rating: _propTypes["default"].number,
  size: _propTypes["default"].oneOfType([_propTypes["default"].oneOf(['small', 'medium', 'large']), _propTypes["default"].shape({
    xxs: _propTypes["default"].string,
    xs: _propTypes["default"].string,
    s: _propTypes["default"].string,
    m: _propTypes["default"].string,
    l: _propTypes["default"].string
  })])
};
var defaultProps = {
  rating: 0,
  size: 'large'
};
var mapSizesForTypography = function mapSizesForTypography(size) {
  var typographySize = {};
  Object.keys(size).forEach(function (key) {
    var ratingSize = size[key];
    typographySize[key] = _config.ratingCssConfig[ratingSize].fontSize;
  });
  return typographySize;
};
var getTypographySize = function getTypographySize(size) {
  return typeof size === 'string' ? _config.ratingCssConfig[size].fontSize : mapSizesForTypography(size);
};
var ratingMarginCss = function ratingMarginCss(ratingSize) {
  return "\n\tmargin: 0 var(".concat(_config.ratingCssConfig[ratingSize].elementSpacing, ") 0 0;\n");
};
var setMargin = function setMargin(size) {
  var _buildResponsiveSize = (0, _fuseUtils.buildResponsiveSize)(size),
    _buildResponsiveSize2 = _slicedToArray(_buildResponsiveSize, 2),
    isResponsive = _buildResponsiveSize2[0],
    setViewportCss = _buildResponsiveSize2[1];
  return isResponsive ? setViewportCss(ratingMarginCss) : ratingMarginCss(size);
};
var StyledTypography = (0, _styledComponents["default"])(_typography.TypographyComponent).withConfig({
  displayName: "rating-number__StyledTypography",
  componentId: "sc-1ruqk7h-0"
})(["", ""], function (_ref) {
  var marginSize = _ref.marginSize;
  return "\n\t\t".concat(setMargin(marginSize), "\n\t");
});
function RatingNumber(_ref2) {
  var size = _ref2.size,
    rating = _ref2.rating;
  return /*#__PURE__*/_react["default"].createElement(StyledTypography, {
    type: "paragraph",
    size: getTypographySize(size),
    marginSize: size
  }, "(".concat(rating, ")"), /*#__PURE__*/_react["default"].createElement(_fuseUtils.SrOnly, null, " out of 5 stars"));
}
RatingNumber.propTypes = propTypes;
RatingNumber.defaultProps = defaultProps;
var _default = exports["default"] = RatingNumber;